import {each} from "lodash";

/**
 * Check if any DatetimePicker input element (year, month, day, ...) is invalid
 *
 * @param {HTMLElement} datetimePickerElement - Datepicker input element.
 * @param {boolean} [includeEmpty=false] - If true, empty input elements will be considered invalid.
 * @return {boolean}
 */
export const isAnyInputInvalid = (datetimePickerElement, includeEmpty) => {
	let result = false;
	each(datetimePickerElement.querySelectorAll(".react-datetime-picker__inputGroup input:not([name=''])"), 
		input => {
			if (!input.checkValidity() || (includeEmpty && input.value === '')) {
				result = true;
				return false;
			}
		}
	);
	return result;
};

/**
 * Get the list of all invalid DatetimePicker input elements (year, month, day, ...)
 *
 * @param {HTMLElement} datetimePickerElement - Datepicker input element.
 * @param {boolean} [includeEmpty=false] - If true, empty input elements will be considered invalid.
 * @return {HTMLElement[]}
 */
export const getInvalidInputs = (datetimePickerElement, includeEmpty = false) => {
	let result = [];
	each(datetimePickerElement.querySelectorAll(".react-datetime-picker__inputGroup input:not([name=''])"), 
		input => { if (!input.checkValidity() || (includeEmpty && input.value === '')) result.push(input); }
	);
	return result;
}